import React, { useEffect, useState } from "react";
// MUI CHARTS
import { LineChart } from "@mui/x-charts/LineChart";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import Box from "@mui/material/Box";
// REDUX
import { useSelector } from "react-redux";
// UTILS
import {
	getChartBackgroundColor,
	getChartTextColor,
	getChartTicklineColor,
	generateLinesData,
	getChartAxisHighlight,
	getAxisLabels,
} from "./utils";
// FAKE DATA
import fakeData from "./FAKEDATA";
// INTERFACES
import { RootState } from "../../../app/store";

function ChartLine() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [labels, setLabels] = useState<string[]>([]);
	const [seriesData, setSeriesData] = useState<any>([]);

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { theme } = useSelector((state: RootState) => state.home);
	const { filters } = useSelector((state: RootState) => state.report);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		if (
			filters &&
			filters.selectedCarsList &&
			filters.selectedCarsList.length > 0
		) {
			let curveType = "linear";
			if (filters.chartType === "line") {
				curveType = "linear";
			} else if (filters.chartType === "line_natural") {
				curveType = "natural";
			} else if (filters.chartType === "step_before") {
				curveType = "stepBefore";
			} else if (filters.chartType === "step_after") {
				curveType = "stepAfter";
			}
			setSeriesData(
				generateLinesData(fakeData.january, curveType, filters.selectedCarsList)
			);
			setLabels(getAxisLabels(fakeData.january, "day"));
		} else {
			setSeriesData([]);
			setLabels(getAxisLabels(fakeData.january, "day"));
		}
	}, [filters.selectedCarsList]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Box sx={{ width: "100%", padding: "10px" }}>
			<LineChart
				axisHighlight={{ x: "line", y: "line" }}
				slotProps={{
					legend: {
						direction: "row",
						position: { vertical: "top", horizontal: "middle" },
						labelStyle: {
							fontSize: 14,
							fill: `${getChartTextColor(theme)}`,
						},
					},
					// Custom message for empty chart
					noDataOverlay: { message: "Select some car." },
				}}
				sx={{
					[`.${axisClasses.root}`]: {
						[`.${axisClasses.tick}, .${axisClasses.line}`]: {
							stroke: `${getChartTicklineColor(theme)}`,
							strokeWidth: 3,
						},
						[`.${axisClasses.tickLabel}`]: {
							fill: `${getChartTextColor(theme)}`,
						},
					},
					[`.MuiChartsLegend-series	`]: {
						stroke: `${getChartAxisHighlight(theme)}`,
					},
					[`.MuiChartsAxisHighlight-root `]: {
						stroke: `${getChartAxisHighlight(theme)}`,
					},
					[`.css-1f57y8b `]: {
						fill: `${getChartTextColor(theme)}`,
					},
					[`.MuiDefaultChartsItemTooltipContent-root	`]: {
						stroke: "blue",
						backgroundColor: "red",
						color: "green",
						border: "yellow",
					},
					borderRadius: "7px",
					backgroundColor: `${getChartBackgroundColor(theme)}`,
				}}
				series={seriesData}
				xAxis={[{ scaleType: "point", data: labels }]}
				height={450}
			/>
		</Box>
	);
}

export default ChartLine;
